export default {
      id: "facebook-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#facebook",
      toString: function () {
        return this.url;
      }
    }